import { FieldArray, useField } from 'formik'
import { MdAdd } from 'react-icons/md'

import type { ReactElement } from 'react'
import type { IIapOption } from '~/types/option'
import type { IEmbeddedUiFormValue } from '~/types/template'

import TextInput from '../TextInput'

import Button from '~/components/Buttons/Button'
import IapInput from '~/components/Inputs/Formik/IapInput'
import Label from '~/components/Label'

import './styles.scss'

interface Props {
  disabled?: boolean
  name: string
  placeholderKey: string
}

const getFieldName = (name: string, suffix: keyof IEmbeddedUiFormValue): string => `${name}.${suffix}`

const EmbeddedUiInputs = ({ disabled, name, placeholderKey }: Props): ReactElement => {
  const [, { value: iapValues }] = useField<IIapOption[] | undefined>(getFieldName(name, 'iaps'))

  const [, { value: navigationTargetValues }] = useField<string[] | undefined>(getFieldName(name, 'navigationTargets'))

  return (
    <div className="embedded-ui-inputs">
      <div className="embedded-ui-inputs__section">
        <div className="embedded-ui-inputs__section__title">
          <Label label="ID" size="large" />
        </div>
        <div className="embedded-ui-inputs__section__content">
          <TextInput
            className="embedded-ui-inputs__section__content__row"
            disabled={disabled}
            name={`${getFieldName(name, 'id')}`}
          />
        </div>
      </div>
      <FieldArray
        name={getFieldName(name, 'iaps')}
        render={({ push, remove }) => (
          <div className="embedded-ui-inputs__section">
            <div className="embedded-ui-inputs__section__title">
              <Label label="In-apps" size="large" />
              {!disabled ? (
                <Button onClick={() => push(undefined)} size="small" type="button">
                  <MdAdd color="#fff" size={15} />
                </Button>
              ) : null}
            </div>
            <div className="embedded-ui-inputs__section__content">
              {iapValues?.map((_, index) => (
                <IapInput
                  className="embedded-ui-inputs__section__content__row"
                  disabled={disabled}
                  key={`iap-input${index}`}
                  name={`${getFieldName(name, 'iaps')}.${index}`}
                  onDelete={() => remove(index)}
                  placeholderKey={placeholderKey}
                />
              ))}
            </div>
          </div>
        )}
      />
      <FieldArray
        name={getFieldName(name, 'navigationTargets')}
        render={({ push, remove }) => (
          <div className="embedded-ui-inputs__section">
            <div className="embedded-ui-inputs__section__title">
              <Label label="Navigation targets" size="large" />
              {!disabled ? (
                <Button onClick={() => push('')} size="small" type="button">
                  <MdAdd color="#fff" size={15} />
                </Button>
              ) : null}
            </div>
            <div className="embedded-ui-inputs__section__content">
              {navigationTargetValues?.map((_, index) => (
                <TextInput
                  className="embedded-ui-inputs__section__content__row"
                  disabled={disabled}
                  key={`navigation-targets-input${index}`}
                  name={`${getFieldName(name, 'navigationTargets')}.${index}`}
                  onDelete={() => remove(index)}
                />
              ))}
            </div>
          </div>
        )}
      />
    </div>
  )
}
export default EmbeddedUiInputs
